import React, { Fragment, useState } from "react";
import AboutUs from "../../components/CompanyProfile/AboutUs";
import Empleos from "../../components/CompanyProfile/Empleos";
import FotosVideos from "../../components/CompanyProfile/FotosVideos";
import AddEventButton from "../Events/AddEventButton";
import EventsList from "../Events/EventsList";
import Formaciones from "./Formaciones";
import Valoraciones from "./Valoraciones";

export const WrapperPerfil = ({ id, company, reload, edit = true }) => {
  function setTab() {}

  const [dispatch, setUpdateEventList] = useState([]);
  const [redirect, setRedirect] = useState(true);
  switch (id) {
    case 1:
      return <AboutUs company={company} reload={reload} edit={edit}></AboutUs>;
    case 2:
      return <Empleos id={company.companyProfileId} edit={edit}></Empleos>;
    case 3:
      return <Formaciones id={company.companyProfileId} edit={edit}></Formaciones>;
    case 5:
      return (
        <FotosVideos id={company.companyProfileId} edit={edit}></FotosVideos>
      );
    case 6:
      return (
        <Valoraciones
          company={company}
          reload={reload}
          edit={edit}
        ></Valoraciones>
      );
    case 7:
      return (
        <Fragment>
          { edit ? <AddEventButton setUpdateEventList={setUpdateEventList}>
            Agregar un evento
          </AddEventButton>: null}
          <EventsList
            redirect={redirect}
            data={company}
            reload={reload}
            edit={edit}
            col={12}
            SetTab={setTab}
            dispatch={dispatch}
          ></EventsList>
        </Fragment>
      );
    default: 
        return <></>
  }
};

export default WrapperPerfil;
